import { compose, mapProps, acceptProps } from 'vue-compose';
import { keyBy } from 'lodash';

import withUser from '~lib/common/hoc/withUser';
import dataView from '~lib/common/hoc/dataView';
import renameProps from '~lib/common/hoc/renameProps';

import CaseAssessments from './CasePhysicalAssessments.vue';
import stateQueries from '~lib/common/queries/State';
import moulageQueries from '../../../graphql/queries/Moulage';

const enhance = compose(
  dataView({
    queries: {
      fetch: moulageQueries.fetch,
    },
  }),
  renameProps({ data: 'availableMoulages' }),
  dataView({ queries: stateQueries }),
  mapProps(props => ({
    ...props,
    physicalAssessmentLocations: keyBy(props.data.find(a => a.id === 'physicalAssessmentLocations').possibleValues, 'key'),
  })),
  acceptProps(['data']),
  withUser(),
);

export default enhance(CaseAssessments);
